export default {
  cancel: null,
  loading: false,
  data: [[], 0]
}
